if (!customElements.get("bfcm-slider")) {
  customElements.define(
    "bfcm-slider",
    class SliderComponent extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          options: this.querySelectorAll(".bfcm-option"),
          atcButton: this.querySelectorAll(".splide-atc"),
          optionSlides: this.querySelectorAll(".option-card"),
          productSelectors: this.querySelectorAll(".product-select"),
          nextButton: this.querySelector('[data-splide-button="next"]')
        };

        this.options = {
          activeSlides: 1
        }

        this.elements.optionSlides.forEach((option, index) => {
            option.addEventListener('click', (e) => {
              console.log("Yes")
              console.log(e.target.dataset.productId)
              $(`.slide-inner-option`).addClass("hidden-slide")
              $(`.slide-inner-${e.target.dataset.productId}`).removeClass("hidden-slide")
            })
        })

        this.elements.options.forEach((option, index) => {
            option.addEventListener('click', (e) => {
              let productSectionSelector = "#hidden-prod-" + e.target.dataset.productId
              let productSection = document.querySelector(productSectionSelector)
              let input = productSection.querySelector(`[value="${e.target.dataset.optionValue}"]`)
              let optionType = e.target.dataset.optionType
              $('.splide-atc').addClass("hidden")
              $(`.splide-atc[data-product-id="${e.target.dataset.productId}"]`).removeClass("hidden")

              if(optionType) {
                $(`[data-option-type="${optionType}"]`).siblings().children().removeClass("selected")
                $(e.target).siblings().children().addClass("selected")
              }

              if(optionType == "Color") {
                console.log("HIT OPTION")
                $(`[data-color-image]`).addClass("hidden-option")
                $(`[data-color-image="${e.target.dataset.optionValue}"]`).removeClass("hidden-option")
              }

              let slide = $(e.target).closest(".splide__slide")[0]
              console.log(slide.dataset.slideIndex)
              if (parseInt(slide.dataset.slideIndex) == 4) {
                console.log("HIT LAST OPTION")
                input.click()
              } else {
                console.log(this.elements.nextButton)
                this.elements.nextButton.click()
              input.click()
              }
            })
        })

        this.elements.productSelectors.forEach((option, index) => {
            option.addEventListener('click', (e) => {
              let optionType = e.target.dataset.optionType

              if(optionType) {
                $(`[data-option-type="${optionType}"]`).siblings().children().removeClass("selected")
                $(e.target).siblings().children().addClass("selected")
              }
            })
        })

        this.elements.atcButton.forEach((option, index) => {
            option.addEventListener('click', (e) => {
              let productSectionSelector = "#hidden-prod-" + e.target.dataset.productId
              let productSection = document.querySelector(productSectionSelector)
              let input = productSection.querySelector(`#AddToCart`)
              input.click()
            })
        })

        
        

        // this.autoPlayOptions = {
        //   delay : parseInt(this.dataset.autoplayDuration),
        //   stopOnMouseEnter : true,
        // }

        // this.plugins = this.autoPlayOptions.delay == 0 ?
        //   [ EmblaCarouselWheelGestures()] :
        //   [ EmblaCarouselWheelGestures(), EmblaCarouselAutoplay(this.autoPlayOptions)]

        // this.sliderApi = new EmblaCarousel(this, this.options, this.plugins );

        // this.elements.thumbnailContainer.innerHTML = this.sliderApi
        //     .scrollSnapList()
        //     .map(() => '<button class="embla__dot h-4 w-4 rounded-full bg-primary-foreground border-primary" type="button"></button>')
        //     .join('')

        // this.elements.thumbnails = Array.from(this.elements.thumbnailContainer.querySelectorAll('.embla__dot'))
        // this.elements.thumbnails.forEach((dotNode, index) => {
        //     dotNode.addEventListener('click', () => this.sliderApi.scrollTo(index), false)
        // })

        // const toggleDotBtnsActive = () => {
        //   const previous = this.sliderApi.previousScrollSnap()
        //   const selected = this.sliderApi.selectedScrollSnap()
        //   this.elements.thumbnails[previous].classList.remove('bg-primary')
        //   this.elements.thumbnails[previous].classList.add('bg-primary-foreground')
        //   this.elements.thumbnails[selected].classList.add('bg-primary')
        //   this.elements.thumbnails[selected].classList.remove('bg-primary-foreground')
        // }

        // this.sliderApi
        //   .on('init', toggleDotBtnsActive)
        //   .on('reInit', toggleDotBtnsActive)
        //   .on('select', toggleDotBtnsActive)

        // this.elements.prevButton.addEventListener('click', this.sliderApi.scrollPrev, false)
        // this.elements.nextButton.addEventListener('click', this.sliderApi.scrollNext, false)
      }

      // disconnectedCallback() {
      //   this.sliderApi.destroy();
      // }
    }
  );
}